"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClayCardWithNavigation = void 0;
var _icon = _interopRequireDefault(require("@clayui/icon"));
var _layout = _interopRequireDefault(require("@clayui/layout"));
var _shared = require("@clayui/shared");
var _sticker = _interopRequireDefault(require("@clayui/sticker"));
var _react = _interopRequireDefault(require("react"));
var _Card = _interopRequireDefault(require("./Card"));
var _CardNavigation = require("./CardNavigation");
var _excluded = ["aria-label", "children", "description", "horizontal", "horizontalSymbol", "href", "onClick", "onKeyDown", "spritemap", "stickerTitle", "title"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var noop = function noop() {};
var ClayCardWithNavigation = exports.ClayCardWithNavigation = function ClayCardWithNavigation(_ref) {
  var ariaLabel = _ref['aria-label'],
    children = _ref.children,
    description = _ref.description,
    _ref$horizontal = _ref.horizontal,
    horizontal = _ref$horizontal === void 0 ? false : _ref$horizontal,
    _ref$horizontalSymbol = _ref.horizontalSymbol,
    horizontalSymbol = _ref$horizontalSymbol === void 0 ? '' : _ref$horizontalSymbol,
    href = _ref.href,
    onClick = _ref.onClick,
    _ref$onKeyDown = _ref.onKeyDown,
    _onKeyDown = _ref$onKeyDown === void 0 ? noop : _ref$onKeyDown,
    spritemap = _ref.spritemap,
    stickerTitle = _ref.stickerTitle,
    title = _ref.title,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_CardNavigation.ClayCardNavigation, _extends({}, otherProps, {
    horizontal: horizontal,
    href: href,
    onClick: onClick,
    onKeyDown: function onKeyDown(event) {
      if (event && event.key === _shared.Keys.Enter || event && event.key === _shared.Keys.Spacebar) {
        event.preventDefault();
        if (onClick) {
          onClick(event);
        }
      }
      _onKeyDown(event);
    },
    tabIndex: 0
  }), !horizontal && /*#__PURE__*/_react.default.createElement(_Card.default.AspectRatio, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "aspect-ratio-item aspect-ratio-item-center-middle aspect-ratio-item-flush"
  }, children)), (horizontal || title || description) && /*#__PURE__*/_react.default.createElement(_Card.default.Body, null, !horizontal && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title && /*#__PURE__*/_react.default.createElement(_Card.default.Description, {
    "aria-label": title,
    displayType: "title",
    truncate: true
  }, title), description && /*#__PURE__*/_react.default.createElement(_Card.default.Description, {
    displayType: "text",
    truncate: true
  }, description)), horizontal && /*#__PURE__*/_react.default.createElement(_Card.default.Row, null, /*#__PURE__*/_react.default.createElement(_layout.default.ContentCol, null, /*#__PURE__*/_react.default.createElement(_sticker.default, {
    inline: true,
    title: stickerTitle
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: horizontalSymbol
  }))), title && /*#__PURE__*/_react.default.createElement(_layout.default.ContentCol, {
    expand: true
  }, /*#__PURE__*/_react.default.createElement(_layout.default.ContentSection, null, /*#__PURE__*/_react.default.createElement(_Card.default.Description, {
    "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : title,
    displayType: "title",
    truncate: true
  }, title))))));
};